"use client";

import { c as _c } from "react/compiler-runtime";
import { InternationalStandingsCompact } from "@/views/standings/overrides/international/InternationalStandingsCompact";
import type { StandingsGroup } from "@/utilities/data/types";
interface StandingsSidebarProps {
  groups: StandingsGroup[];
}

/**
 * Thin wrapper around `InternationalStandingsCompact` — the same component used
 * for World Cup / Euros standings sidebars. Pre-bucketed group data goes in,
 * a tabbed compact table comes out.
 */
export function StandingsSidebar(t0) {
  const $ = _c(2);
  const {
    groups
  } = t0;
  let t1;
  if ($[0] !== groups) {
    t1 = <InternationalStandingsCompact groups={groups} standingsUrl="#" groupsPerTab={2} />;
    $[0] = groups;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}